module.exports = __webpack_public_path__ + "img/isa_indicatori.09529943.png";